import { useContext } from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { Button } from '../../../../FormStyles/Button';
import { surveyTexts } from '../tileAndButtonTexts';
import TileButton from '../components/TileButton.jsx';
import AddAnswer from '../components/AddAnswer.jsx';
import ToggleSwitch from '../../../../FormStyles/ToggleSwitch.jsx';
import i18n from '../../../../../app/i18n';
import ToggleWrapper from '../components/ToggleWrapper';
import { InteractionContext } from '../../../contexts';
import defaultAttrs from '../../../../../lib/utils/defaultAttrs';

const OtherButton = () => {
  return (
    <OtherButtonWrapper>
      <TileButtonOtherDisplay
        onClick={e => e.preventDefault()}
        variant="answerBlue"
        data-tip={i18n.t(
          'tileForm:interaction.types.survey.survey_multiple_choice.otherHoverText',
        )}
      >
        {i18n.t(
          'tileForm:interaction.types.survey.survey_multiple_choice.otherButtonText',
        )}
      </TileButtonOtherDisplay>
      <QuestionIcon />
      <ReactTooltip
        place="top"
        effect="solid"
        type="light"
        getContent={() => (
          <TooltipContent>
            {i18n.t(
              'tileForm:interaction.types.survey.survey_multiple_choice.otherHoverText',
            )}
          </TooltipContent>
        )}
      />
    </OtherButtonWrapper>
  );
};

const Multiplechoice = ({ option }) => {
  const {
    values,
    handleChange,
    handleAddAnswer,
    handleRemoveAnswer,
  } = useContext(InteractionContext);

  return (
    <>
      {values.answers.map((answer, i) => (
        <TileButton
          key={`multiple_choice_button_${i}`}
          buttonText={answer}
          buttonIndex={i}
          isRemovable={true}
          onRemove={handleRemoveAnswer}
          onChangeButtonText={handleChange}
          isOther={values.allowFreeResponse}
        />
      ))}
      {values.allowFreeResponse && <OtherButton />}
      <AddAnswer
        onClick={() => handleAddAnswer(surveyTexts[option].buttonText)}
      />
      <ToggleWrapper>
        <ToggleSwitch
          value={values.allowFreeResponse}
          onChange={handleChange}
          name="allowFreeResponse"
          id="allowFreeResponse"
          label={i18n.t('tileForm:interaction.toggleLabels.allowFreeResponse')}
          color="black.80"
          fontWeight="400"
          margin="10px 0"
          invertLabelPosition
        />
      </ToggleWrapper>
      <ToggleWrapper>
        <ToggleSwitch
          value={values.isAnonymous}
          onChange={handleChange}
          name="isAnonymous"
          id="isAnonymous"
          label={i18n.t('tileForm:interaction.toggleLabels.makeTileAnonymous')}
          color="black.80"
          fontWeight="400"
          margin="0 0 10px 0"
          invertLabelPosition
        />
      </ToggleWrapper>
    </>
  );
};

export default Multiplechoice;

const TileButtonOtherDisplay = styled(Button)`
  background: linear-gradient(
    253.58deg,
    ${themeGet('colors.primary.70')} 1.55%,
    ${themeGet('colors.primary.100')} 95.8%
  );
  padding: 10px 20px;
  position: relative;
  clear: both;
  font-weight: normal;
  width: 100%;
  font-size: 20px;
  line-height: 25px;
  min-height: 45px;

  &:hover {
    background: linear-gradient(
      253.58deg,
      ${themeGet('colors.primary.70')} 1.55%,
      ${themeGet('colors.primary.80')} 95.8%
    );
    cursor: help;
  }
  &:active {
    box-shadow: none;
  }
`;

const TooltipContent = styled.div`
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  max-width: 350px;
`;

const QuestionIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-regular fa-circle-question-mark',
  }),
)`
  width: 15px;
  height: 15px;
  margin-left: 5px;
  cursor: help;
`;

const OtherButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0px;
  position: relative;
  clear: both;
  font-weight: normal;
`;
